(function () {
  'use strict';

  // --- Filter accordions ---
  document.querySelectorAll('[data-facet-group]').forEach(function (group) {
    var toggle = group.querySelector('.facets__group-toggle');
    if (!toggle) return;
    toggle.addEventListener('click', function () {
      var isOpen = group.getAttribute('data-open') === 'true';
      group.setAttribute('data-open', String(!isOpen));
      toggle.setAttribute('aria-expanded', String(!isOpen));
    });
  });

  // --- Mobile filter drawer ---
  var filterToggle = document.getElementById('MobileFilterToggle');
  var sidebar = document.getElementById('CollectionFilters');
  if (filterToggle && sidebar) {
    filterToggle.addEventListener('click', function () {
      var isOpen = sidebar.classList.toggle('is-open');
      filterToggle.setAttribute('aria-expanded', String(isOpen));
      /* Locks the underlying page's own scroll while the full-screen
         mobile filter drawer is open (assets/collection-grid.css) -
         the drawer itself keeps scrolling normally via its own
         overflow-y:scroll, only the page behind it is locked. */
      document.body.classList.toggle('collection-filters-open', isOpen);
    });
  }

  function closeMobileFilterDrawer() {
    sidebar.classList.remove('is-open');
    if (filterToggle) filterToggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('collection-filters-open');
  }

  // --- Mobile filter drawer: sticky "Show All" footer button - filters
  // already apply live on checkbox change (applyFacets() below reloads
  // the page), so this just closes the drawer to reveal the
  // already-updated results underneath, same as dismissing it any
  // other way.
  var showAllButton = document.querySelector('[data-show-all-filters]');
  if (showAllButton && sidebar) {
    showAllButton.addEventListener('click', closeMobileFilterDrawer);
  }

  // --- Mobile filter drawer: X button beside "Clear filters" - closes
  // the drawer only, without clearing any selected filters (that's
  // still [data-clear-filters]'s own job).
  var closeButton = document.querySelector('[data-close-filters]');
  if (closeButton && sidebar) {
    closeButton.addEventListener('click', closeMobileFilterDrawer);
  }

  // --- Custom desktop sidebar scrollbar (always visible, not tied to
  // native overflow scrollbar rendering - see collection-grid.css for
  // why) ---
  var filtersScroll = document.querySelector('[data-filters-scroll]');
  var scrollTrack = document.querySelector('[data-scrollbar-track]');
  var scrollThumb = document.querySelector('[data-scrollbar-thumb]');
  if (filtersScroll && scrollTrack && scrollThumb) {
    var desktopQuery = window.matchMedia('(min-width: 990px)');

    var updateThumb = function () {
      if (!desktopQuery.matches) return;
      var scrollHeight = filtersScroll.scrollHeight;
      var visibleHeight = filtersScroll.clientHeight;
      if (scrollHeight <= visibleHeight) {
        scrollTrack.hidden = true;
        return;
      }
      scrollTrack.hidden = false;
      var trackHeight = scrollTrack.clientHeight;
      var thumbHeight = Math.max((visibleHeight / scrollHeight) * trackHeight, 24);
      var maxThumbTop = trackHeight - thumbHeight;
      var maxScrollTop = scrollHeight - visibleHeight;
      var thumbTop = maxScrollTop > 0 ? (filtersScroll.scrollTop / maxScrollTop) * maxThumbTop : 0;
      scrollThumb.style.height = thumbHeight + 'px';
      scrollThumb.style.top = thumbTop + 'px';
    };

    filtersScroll.addEventListener('scroll', updateThumb);
    window.addEventListener('resize', updateThumb);
    desktopQuery.addEventListener('change', updateThumb);
    updateThumb();
    // Fonts/images loading can change content height after first paint.
    window.addEventListener('load', updateThumb);
  }

  // --- Facet checkboxes / price inputs update the URL and reload results ---
  var form = document.getElementById('FacetFiltersForm');
  if (form) {
    form.addEventListener('change', function (event) {
      if (event.target.matches('[data-facet-checkbox], [data-facet-input]')) {
        applyFacets();
      }
    });
  }

  var clearButton = document.querySelector('[data-clear-filters]');
  if (clearButton) {
    clearButton.addEventListener('click', function () {
      window.location.href = window.location.pathname;
    });
  }

  function applyFacets() {
    var params = new URLSearchParams(window.location.search);
    var formData = new FormData(form);
    var next = new URLSearchParams();

    // Preserve sort
    if (params.get('sort_by')) next.set('sort_by', params.get('sort_by'));

    formData.forEach(function (value, key) {
      if (value) next.append(key, value);
    });

    window.location.search = next.toString();
  }

  // --- Sort (custom dropdown: bordered trigger button + panel of
  // radio-style options, replacing the native <select>) ---
  var sortDropdown = document.querySelector('[data-sort-dropdown]');
  var sortTrigger = document.getElementById('SortTrigger');
  var sortPanel = document.getElementById('SortPanel');
  if (sortDropdown && sortTrigger && sortPanel) {
    var closeSortPanel = function () {
      sortPanel.hidden = true;
      sortTrigger.setAttribute('aria-expanded', 'false');
    };
    var openSortPanel = function () {
      sortPanel.hidden = false;
      sortTrigger.setAttribute('aria-expanded', 'true');
    };

    sortTrigger.addEventListener('click', function () {
      if (sortPanel.hidden) {
        openSortPanel();
      } else {
        closeSortPanel();
      }
    });

    sortPanel.querySelectorAll('[data-sort-option]').forEach(function (optionButton) {
      optionButton.addEventListener('click', function () {
        var params = new URLSearchParams(window.location.search);
        params.set('sort_by', optionButton.getAttribute('data-value'));
        window.location.search = params.toString();
      });
    });

    document.addEventListener('click', function (event) {
      if (!sortDropdown.contains(event.target)) closeSortPanel();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeSortPanel();
    });
  }

  // --- Quick add (adds default/first-available variant via Ajax Cart API) ---
  document.querySelectorAll('[data-quick-add]').forEach(function (button) {
    button.addEventListener('click', function () {
      var variantId = button.getAttribute('data-variant-id');
      if (!variantId || variantId === '') return;

      button.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Could not add to cart');
          return res.json();
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:updated'));
          document.dispatchEvent(new CustomEvent('cart:open'));
        })
        .catch(function (err) {
          console.error(err);
        })
        .finally(function () {
          button.disabled = false;
        });
    });
  });
})();